(() => {
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => Array.from(c.querySelectorAll(s));
  const route = path => (window.Shopify?.routes?.root || '/') + path.replace(/^\//, '');
  let cartCurrency = document.body.dataset.currency || 'USD';
  let lastKnownCart = null;
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:cartCurrency}).format((cents || 0) / 100);
  let activeOverlay = null;
  let overlayReturnFocus = null;
  const inertState = new Map();
  const overlayFocusable = el => qsa('a[href],button,input,select,textarea,summary,[tabindex="0"]', el).filter(node => !node.disabled && !node.closest('[hidden]') && node.getClientRects().length);
  const setOverlay = (el, open) => {
    if (!el) return;
    if (open) {
      if (activeOverlay === el) return;
      if (activeOverlay) setOverlay(activeOverlay, false);
      overlayReturnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      activeOverlay = el;
      el.hidden = false;
      for (const candidate of qsa('body *')) {
        if (candidate === el || candidate.contains(el) || el.contains(candidate) || candidate.closest('.jymoor-overlay')) continue;
        if (candidate.parentElement !== document.body && !candidate.parentElement?.contains(el)) continue;
        inertState.set(candidate, candidate.inert);
        candidate.inert = true;
      }
      (qs('input[type="search"]', el) || overlayFocusable(el)[0])?.focus({preventScroll:true});
    } else {
      el.hidden = true;
      if (activeOverlay !== el) return;
      activeOverlay = null;
      inertState.forEach((value, node) => { node.inert = value; });
      inertState.clear();
      if (overlayReturnFocus && document.contains(overlayReturnFocus)) overlayReturnFocus.focus({preventScroll:true});
      overlayReturnFocus = null;
    }
    document.documentElement.classList.toggle('jymoor-overlay-open', Boolean(activeOverlay));
    document.body.classList.toggle('jymoor-overlay-open', Boolean(activeOverlay));
  };
  document.addEventListener('keydown', e => {
    if (!activeOverlay) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      setOverlay(activeOverlay, false);
      qs('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
    } else if (e.key === 'Tab') {
      const nodes = overlayFocusable(activeOverlay);
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { e.preventDefault(); return; }
      if (e.shiftKey && (document.activeElement === first || !activeOverlay.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !activeOverlay.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  }, true);

  const mobile = qs('[data-mobile-menu]');
  const mobileOpen = qs('[data-mobile-menu-open]');
  mobileOpen?.addEventListener('click', () => {
    setOverlay(mobile, true);
    mobileOpen.setAttribute('aria-expanded', 'true');
  });
  qs('[data-mobile-menu-close]')?.addEventListener('click', () => {
    setOverlay(mobile, false);
    mobileOpen?.setAttribute('aria-expanded', 'false');
  });

  const header = qs('[data-jymoor-header]');
  const megaTriggers = qsa('[data-mega-trigger]');
  const megaPanels = qsa('[data-mega-panel]');
  const megaBackdrop = qs('[data-mega-backdrop]');
  let activeMega = null;
  let megaOpenTimer = null;
  let megaCloseTimer = null;

  const syncHeaderHeight = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--jymoor-header-current', header.getBoundingClientRect().height + 'px');
  };

  const syncShopMegaPosition = () => {
    if (window.innerWidth < 990) return;
    const trigger = qs('[data-mega-trigger="shop"]');
    const panel = qs('[data-mega-panel="shop"]');
    if (!trigger || !panel) return;
    const left = Math.round(trigger.getBoundingClientRect().left);
    panel.style.setProperty('--jymoor-shop-trigger-left', left + 'px');
  };

  const setMega = (name) => {
    clearTimeout(megaOpenTimer);
    clearTimeout(megaCloseTimer);
    activeMega = name || null;
    megaPanels.forEach(panel => panel.hidden = panel.dataset.megaPanel !== activeMega);
    megaTriggers.forEach(trigger => trigger.setAttribute('aria-expanded', trigger.dataset.megaTrigger === activeMega ? 'true' : 'false'));
    if (megaBackdrop) megaBackdrop.hidden = !activeMega;
    document.documentElement.classList.toggle('jymoor-mega-open', Boolean(activeMega));
    if (activeMega === 'shop') syncShopMegaPosition();
    syncHeaderHeight();
  };

  const scheduleMegaOpen = (name) => {
    clearTimeout(megaCloseTimer);
    clearTimeout(megaOpenTimer);
    megaOpenTimer = setTimeout(() => setMega(name), activeMega ? 30 : 90);
  };

  const scheduleMegaClose = () => {
    clearTimeout(megaOpenTimer);
    clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(() => setMega(null), 130);
  };

  megaTriggers.forEach(trigger => {
    trigger.addEventListener('mouseenter', () => scheduleMegaOpen(trigger.dataset.megaTrigger));
    trigger.addEventListener('focus', () => setMega(trigger.dataset.megaTrigger));
    trigger.addEventListener('click', () => setMega(activeMega === trigger.dataset.megaTrigger ? null : trigger.dataset.megaTrigger));
  });
  megaPanels.forEach(panel => {
    panel.addEventListener('mouseenter', () => clearTimeout(megaCloseTimer));
    panel.addEventListener('mouseleave', scheduleMegaClose);
    qsa('a', panel).forEach(link => link.addEventListener('click', () => setMega(null)));
  });
  qsa('[data-mega-close-link]').forEach(link => {
    link.addEventListener('mouseenter', scheduleMegaClose);
    link.addEventListener('focus', () => setMega(null));
  });
  header?.addEventListener('mouseleave', scheduleMegaClose);
  megaBackdrop?.addEventListener('click', () => setMega(null));

  const syncScrolledHeader = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
    requestAnimationFrame(syncHeaderHeight);
  };
  syncScrolledHeader();
  window.addEventListener('scroll', syncScrolledHeader, {passive:true});
  window.addEventListener('resize', () => {
    syncHeaderHeight();
    syncShopMegaPosition();
  }, {passive:true});

  qsa('.jymoor-mobile-nav-v2__group').forEach(group => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      qsa('.jymoor-mobile-nav-v2__group').forEach(other => {
        if (other !== group) other.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', e => {
    if (activeMega && header && !header.contains(e.target) && e.target !== megaBackdrop) setMega(null);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      setMega(null);
      if (mobile && !mobile.hidden) {
        setOverlay(mobile, false);
        mobileOpen?.setAttribute('aria-expanded', 'false');
      }
    }
  });

  const search = qs('[data-search-overlay]');
  qs('[data-search-open]')?.addEventListener('click', () => {
    setMega(null);
    setOverlay(search, true);

  });
  qs('[data-search-close]')?.addEventListener('click', () => setOverlay(search, false));

  const cartOverlay = qs('[data-cart-overlay]');
  const cartBody = qs('[data-cart-drawer-body]');
  const cartSubtotal = qs('[data-cart-subtotal]');

  let cartBusy = false;
  const disabledBefore = new WeakMap();
  const cartControls = () => qsa('[data-cart-change],.js-ajax-add-to-cart [type="submit"],[data-cart-refresh]');
  const lockCart = busy => {
    cartBusy = busy;
    cartControls().forEach(button => {
      if (busy) { if (!disabledBefore.has(button)) disabledBefore.set(button, button.disabled); button.disabled = true; }
      else { button.disabled = disabledBefore.get(button) || false; disabledBefore.delete(button); }
    });
    cartBody?.setAttribute('aria-busy', String(busy));
  };
  const cartError = qs('[data-cart-error]');
  const showCartError = message => {
    if (!cartError) return;
    cartError.textContent = message || '';
    cartError.hidden = !message;
  };
  async function requestJSON(path, options = {}) {
    const response = await fetch(route(path), options);
    const raw = await response.text();
    let payload = {};
    try {
      payload = raw ? JSON.parse(raw) : {};
    } catch {
      throw new Error(response.ok
        ? 'Unexpected response from the store. Please review your cart before trying again.'
        : 'Unable to update your cart. Please try again.');
    }
    if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to update your cart. Please try again.');
    return payload;
  }
  async function getCart() {
    const cart = await requestJSON('cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!Array.isArray(cart.items) || !Number.isFinite(cart.item_count)) throw new Error('Unable to load your cart. Please try again.');
    return cart;
  }
  function renderCart(cart) {
    lastKnownCart = cart;
    cartCurrency = cart.currency || cartCurrency;
    qsa('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count > 9 ? '9+' : cart.item_count;
      el.hidden = cart.item_count < 1;
    });
    if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
    if (!cartBody) return;
    if (!cart.item_count) {
      cartBody.innerHTML = '<p>Your cart is empty.</p><a class="jymoor-button jymoor-button--secondary" href="' + escapeHTML(route('collections/all')) + '">Continue shopping</a>';
      return;
    }
    cartBody.innerHTML = cart.items.map(item => `
      <div class="jymoor-cart-mini">
        <a href="${escapeHTML(item.url)}"><img src="${escapeHTML(item.image || '')}" alt="${escapeHTML(item.product_title)}"></a>
        <div>
          <a class="jymoor-cart-mini__title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="jymoor-cart-mini__meta">${escapeHTML(item.variant_title)}</div>` : ''}
          <div class="jymoor-cart-mini__qty">
            <button type="button" data-cart-change data-key="${escapeHTML(item.key)}" data-qty="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change data-key="${escapeHTML(item.key)}" data-qty="${item.quantity+1}" aria-label="Increase quantity">+</button>
          </div>
          <button class="jymoor-cart-mini__remove" type="button" data-cart-change data-key="${escapeHTML(item.key)}" data-qty="0">Remove</button>
        </div>
        <strong>${money(item.final_line_price)}</strong>
      </div>`).join('');
    qsa('[data-cart-change]', cartBody).forEach(button => button.addEventListener('click', async () => {
      if (cartBusy) return;
      lockCart(true);
      showCartError('');
      try {
        const cart = await requestJSON('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:button.dataset.key,quantity:Number(button.dataset.qty)})});
        if (!Array.isArray(cart.items)) throw new Error('Unable to update your cart.');
        renderCart(cart);
      } catch (error) {
        try { renderCart(await getCart()); } catch { /* Keep the last known cart visible. */ }
        showCartError(error.message || 'Connection interrupted. Reload your cart before trying again.');
      } finally {
        lockCart(false);
        const replacement = qsa('[data-cart-change]', cartBody).find(el => el.dataset.key === button.dataset.key && el.getAttribute('aria-label') === button.getAttribute('aria-label'));
        (replacement || qs('[data-cart-close]'))?.focus({preventScroll:true});
      }
    }));
    if (cartBusy) lockCart(true);
  }
  async function openCart() {
    setMega(null);
    setOverlay(cartOverlay, true);
    showCartError('');
    const ownsLock = !cartBusy;
    if (ownsLock) lockCart(true);
    try { renderCart(await getCart()); }
    catch {
      if (lastKnownCart) renderCart(lastKnownCart);
      else if (cartBody?.textContent.includes('Loading cart')) cartBody.textContent = 'Your cart could not be loaded.';
      showCartError('Unable to load your cart. Check your connection, then select Reload cart.');
    } finally { if (ownsLock) lockCart(false); }
  }
  qs('[data-cart-open]')?.addEventListener('click', () => { if (!cartBusy) openCart(); });
  qs('[data-cart-refresh]')?.addEventListener('click', () => { if (!cartBusy) openCart(); });
  qs('[data-cart-close]')?.addEventListener('click', () => setOverlay(cartOverlay, false));
  qsa('.jymoor-overlay').forEach(overlay => overlay.addEventListener('click', e => {
    if (e.target === overlay) {
      setOverlay(overlay, false);
      if (overlay === mobile) mobileOpen?.setAttribute('aria-expanded', 'false');
    }
  }));
  qsa('.js-ajax-add-to-cart').forEach(form => form.addEventListener('submit', async e => {
    e.preventDefault();
    if (cartBusy) return;

    let message = qs('[data-add-error]', form);
    if (!message) {
      message = document.createElement('p');
      message.dataset.addError = '';
      message.className = 'jymoor-form-message';
      message.setAttribute('role','alert');
      form.append(message);
    }

    // If an earlier add may have reached Shopify but its response was lost,
    // reconcile the cart before allowing another add. This prevents accidental duplicates.
    if (form.dataset.cartReviewRequired === 'true') {
      message.textContent = 'Review or reload your cart before trying again.';
      setOverlay(cartOverlay, true);
      lockCart(true);
      try {
        renderCart(await getCart());
        delete form.dataset.cartReviewRequired;
        message.textContent = '';
      } catch {
        message.textContent = 'We still cannot confirm your cart. Check your connection and reload the cart before trying again.';
      } finally {
        lockCart(false);
      }
      return;
    }

    message.textContent = '';
    lockCart(true);
    try {
      await requestJSON('cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      delete form.dataset.cartReviewRequired;
      await openCart();
    } catch (error) {
      const ambiguous = error instanceof TypeError ||
        String(error?.message || '').includes('Unexpected response from the store');

      if (ambiguous) {
        form.dataset.cartReviewRequired = 'true';
        try {
          const reconciled = await getCart();
          renderCart(reconciled);
          setOverlay(cartOverlay, true);
          delete form.dataset.cartReviewRequired;
          message.textContent = 'Cart refreshed. Review it before adding again.';
        } catch {
          message.textContent = 'We could not confirm this update. Reload your cart before trying again.';
        }
      } else {
        message.textContent = error?.message || 'Unable to add this item. Please try again.';
      }
    } finally {
      lockCart(false);
    }
  }));

  qsa('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const scope = select.closest('[data-product-scope]');
    const price = qs('[data-product-price]', scope);
    const submit = qs('[type="submit"]', scope);
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (submit) {
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? 'Add to cart' : 'Sold out';
    }
  }));

  qsa('[data-auto-submit]').forEach(el => el.addEventListener('change', () => el.form?.submit()));
  qsa('[data-filter-auto-submit]').forEach(el => el.addEventListener('change', () => el.form?.submit()));

  const footerBreakpoint = window.matchMedia('(max-width: 749px)');
  const syncFooterGroups = () => {
    const mobileFooter = footerBreakpoint.matches;
    qsa('.jymoor-footer-group').forEach(group => {
      if (mobileFooter) group.removeAttribute('open');
      else group.setAttribute('open', '');
    });
  };
  syncFooterGroups();
  footerBreakpoint.addEventListener('change', syncFooterGroups);
  const guideContent = qs('[data-guide-content]');
  const toc = qs('[data-guide-toc]');
  const tocWrap = qs('[data-guide-toc-wrap]');
  if (guideContent) {
    qsa('h2', guideContent).forEach(h => {
      if (h.textContent.trim().toLowerCase() === 'related guides') {
        const next = h.nextElementSibling;
        if (next && (next.tagName === 'UL' || next.tagName === 'OL')) next.remove();
        h.remove();
      }
    });

    const headings = qsa('h2', guideContent);
    if (toc && headings.length) {
      const used = new Set();
      headings.forEach((heading, index) => {
        let slug = heading.textContent.trim().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '') || ('section-' + (index + 1));
        let unique = slug;
        let n = 2;
        while (used.has(unique)) unique = slug + '-' + n++;
        used.add(unique);
        heading.id = unique;
        const a = document.createElement('a');
        a.href = '#' + unique;
        a.textContent = heading.textContent.trim();
        toc.appendChild(a);
      });
    } else if (tocWrap) {
      tocWrap.hidden = true;
    }
  }
  // Final storefront UX enhancements.
  const syncVariant = (input, updateURL = true) => {
    if (!input?.checked) return;
    const scope = input.closest('[data-product-scope]');
    const price = qs('[data-product-price]', scope);
    const submit = qs('[data-product-submit]', scope);
    if (price && input.dataset.price) price.textContent = input.dataset.price;
    if (submit) {
      const available = input.dataset.available === 'true';
      submit.disabled = cartBusy || !available;
      if (cartBusy) disabledBefore.set(submit, !available);
      submit.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (updateURL) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    }
    if (input.dataset.mediaId) {
      const gallery = qs('[data-product-gallery]', scope);
      const item = qsa('[data-gallery-item]', scope).find(el => el.dataset.mediaId === input.dataset.mediaId);
      if (item && gallery) {
        const behavior = updateURL ? 'smooth' : 'auto';
        if (window.matchMedia('(max-width: 989px)').matches) gallery.scrollTo({left:item.offsetLeft - gallery.offsetLeft,behavior});
        else item.scrollIntoView({block:'nearest',behavior});
      }
    }
  };
  qsa('[data-variant-radio]').forEach(input => input.addEventListener('change', () => syncVariant(input)));
  const initialVariant = qs('[data-variant-radio]:checked');
  if (initialVariant && new URL(window.location.href).searchParams.has('variant')) syncVariant(initialVariant, false);
  window.addEventListener('popstate', () => {
    const variant = new URL(window.location.href).searchParams.get('variant');
    const input = qsa('[data-variant-radio]').find(el => el.value === variant);
    if (input) { input.checked = true; syncVariant(input, false); }
  });

  qsa('[data-qty-stepper]').forEach(stepper => {
    const input = qs('[data-qty-input]', stepper);
    if (!input) return;
    qsa('[data-qty-action]', stepper).forEach(button => button.addEventListener('click', () => {
      const min = Number(input.min || 0);
      const current = Number(input.value || min || 0);
      const next = button.dataset.qtyAction === 'plus' ? current + 1 : Math.max(min, current - 1);
      input.value = next;
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }));
  });

  qsa('[data-product-gallery]').forEach(gallery => {
    const items = qsa('[data-gallery-item]', gallery);
    const counter = qs('[data-gallery-current]', gallery);
    if (!counter || items.length < 2) return;
    let ticking = false;
    const updateCounter = () => {
      const center = gallery.scrollLeft + gallery.clientWidth / 2;
      let closest = 0;
      let distance = Infinity;
      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const d = Math.abs(itemCenter - center);
        if (d < distance) { distance = d; closest = index; }
      });
      counter.textContent = String(closest + 1);
      ticking = false;
    };
    gallery.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateCounter);
      }
    }, {passive:true});
  });

  const tocDetails = qs('[data-guide-toc-details]');
  if (tocDetails) {
    const syncGuideToc = () => {
      if (window.matchMedia('(max-width: 749px)').matches) tocDetails.removeAttribute('open');
      else tocDetails.setAttribute('open', '');
    };
    syncGuideToc();
    window.addEventListener('resize', syncGuideToc, {passive:true});
  }

  const predictiveForm = qs('[data-predictive-search-form]');
  if (predictiveForm) {
    const input = qs('[data-predictive-search-input]', predictiveForm);
    const results = qs('[data-predictive-search-results]', predictiveForm);
    let timer;
    let searchSequence = 0;
    const escapeHTML = value => String(value || '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
    input?.addEventListener('input', () => {
      clearTimeout(timer);
      const sequence = ++searchSequence;
      const term = input.value.trim();
      if (term.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(async () => {
        try {
          const url = route('search/suggest.json') + '?q=' + encodeURIComponent(term) + '&resources[type]=product,page&resources[limit]=6';
          const response = await fetch(url, {headers:{'Accept':'application/json'}});
          if (!response.ok) throw new Error();
          const payload = await response.json();
          if (sequence !== searchSequence) return;
          const found = payload?.resources?.results || {};
          const products = found.products || [];
          const pages = found.pages || [];
          if (!products.length && !pages.length) {
            results.innerHTML = '<p class="jymoor-predictive-search__empty">No suggestions yet.</p>';
            results.hidden = false;
            return;
          }
          const productHTML = products.map(item => '<a href="' + escapeHTML(item.url) + '"><span>Product</span><strong>' + escapeHTML(item.title) + '</strong></a>').join('');
          const pageHTML = pages.map(item => '<a href="' + escapeHTML(item.url) + '"><span>Guide</span><strong>' + escapeHTML(item.title) + '</strong></a>').join('');
          results.innerHTML = productHTML + pageHTML;
          results.hidden = false;
        } catch {
          if (sequence === searchSequence) results.hidden = true;
        }
      }, 180);
    });
    predictiveForm.addEventListener('focusout', () => setTimeout(() => { if (!predictiveForm.contains(document.activeElement)) results.hidden = true; }, 120));
  }
  const infoContent = qs('[data-jymoor-info-content]');
  if (infoContent) {
    const directChildren = Array.from(infoContent.children);
    const headingNodes = directChildren.filter(el => el.matches('h2,h3'));
    if (headingNodes.length >= 2) {
      const intro = document.createElement('div');
      intro.className = 'jymoor-info-page__intro';
      const accordion = document.createElement('div');
      accordion.className = 'jymoor-info-accordion';

      let currentBody = null;
      let sectionIndex = 0;
      directChildren.forEach(el => {
        if (el.matches('h2,h3')) {
          sectionIndex += 1;
          const details = document.createElement('details');
          details.className = 'jymoor-info-accordion__item';
          if (sectionIndex === 1) details.open = true;

          const summary = document.createElement('summary');
          const number = document.createElement('span');
          number.className = 'jymoor-info-accordion__number';
          number.textContent = String(sectionIndex).padStart(2, '0');

          const title = document.createElement('span');
          title.className = 'jymoor-info-accordion__title';
          title.textContent = el.textContent.trim();

          const toggle = document.createElement('span');
          toggle.className = 'jymoor-info-accordion__toggle';
          toggle.setAttribute('aria-hidden', 'true');

          summary.append(number, title, toggle);
          currentBody = document.createElement('div');
          currentBody.className = 'jymoor-info-accordion__body';
          details.append(summary, currentBody);
          accordion.append(details);
          el.remove();
        } else if (currentBody) {
          currentBody.append(el);
        } else {
          intro.append(el);
        }
      });

      infoContent.innerHTML = '';
      if (intro.children.length) infoContent.append(intro);
      infoContent.append(accordion);
      infoContent.classList.add('is-accordion');
    }
  }

})();
